// extracted by mini-css-extract-plugin
module.exports = {"container":"PageFour_container__2zVkd","main-container":"PageFour_main-container__3jZbn","swiper-container":"PageFour_swiper-container__8rxB_"};